var modals = function () {
  var toggleModals = function () {
    var modal = document.getElementsByClassName('modal');

    for (let i = 0; i < modal.length; i += 1) {
      modal[i].classList.remove('modal--open');
      modal[i].classList.add('modal--close');
    }
  };

  var elements = document.querySelectorAll('[data-toggle]');
  for (let i = 0; i < elements.length; i += 1) {
    var el = elements[i];
    el.addEventListener('click', (e) => {
      if (e.currentTarget.hasAttribute('data-target')) {
        var id = e.currentTarget.getAttribute('data-target');

        var targetEl = document.getElementById(id);
        if (targetEl) {
          targetEl.classList.add('modal--open');
          targetEl.classList.remove('modal--close');
        }
        e.preventDefault();
      }
    });
  }

  var dismissers = document.querySelectorAll('[data-dismiss]');
  var dismissHandler = (e) => {
    if (e.currentTarget.getAttribute('data-dismiss') === 'modal' || e.currentTarget.classList.contains('modal')) {
      toggleModals();
      e.preventDefault();
    }
  };

  for (let j = 0; j < dismissers.length; j += 1) {
    var dismiss = dismissers[j];

    dismiss.addEventListener('click', dismissHandler);
  }

  document.addEventListener('keydown', (e) => {
    var keyDown = e.keyCode;

    if (keyDown === 27) {
      toggleModals();
    }
  });
};

export default modals;
